import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { createFocusRingStyles } from "../../../util/createFocusRingStyles";
import { chipCustomCssProperties } from "./chipConstants";
import { chipTheme } from "./chipTheme";
export var ChipContainer = styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    height: ", ";\n    padding-left: var(--smar--sds--chip--padding-left, 4px);\n    padding-right: var(--smar--sds--chip--padding-right, 4px);\n\n    border-radius: ", ";\n\n    display: inline-flex;\n    flex-direction: row;\n    align-items: center;\n    cursor: default;\n\n    // For the X button's absolute position.\n    position: relative;\n\n    max-width: 100%;\n    min-height: var(--smar--sds--chip--min-height);\n    transition: ", ";\n\n    // TODO if we extract these 4 token usages behind 4 css properties private to the Chip, we can\n    // set those in the component's render and not have to create a unique className for each of\n    // these variants.\n    color: var(", ");\n    background-color: var(", ");\n\n    ", "\n\n    ", "\n"])), function (_ref) {
  var size = _ref.size,
    themeMode = _ref.themeMode;
  return "var(--smar--sds--chip--height, ".concat(chipTheme.height[size](themeMode), ")");
}, function (_ref2) {
  var themeMode = _ref2.themeMode;
  return "var(--smar--sds--chip--border-radius, ".concat(chipTheme.borderRadius(themeMode), ")");
}, function (_ref3) {
  var themeMode = _ref3.themeMode;
  return chipTheme.motion.animation(themeMode);
}, chipCustomCssProperties.text, chipCustomCssProperties.backgroundRest, function (_ref4) {
  var isReadonly = _ref4.isReadonly;
  if (!isReadonly) {
    return "\n                    ".concat(chipCustomCssProperties.removeButtonOpacity, ": 0.0;\n                    &:hover {\n                        background-color: var(").concat(chipCustomCssProperties.backgroundHover, ");\n                        ").concat(chipCustomCssProperties.removeButtonOpacity, ": 1.0;\n                    }\n            ");
  }
}, function (_ref5) {
  var themeMode = _ref5.themeMode;
  return createFocusRingStyles({
    theme: themeMode,
    // Place the ring just inside the content box.
    gap: -2,
    componentBorderWidth: 0,
    componentRadius: chipTheme.borderRadius(themeMode),
    focusSelector: ":focus-visible",
    componentRadiusOverride: "var(--smar--sds--chip--border-radius)"
  });
});
//# sourceMappingURL=ChipContainer.js.map